import React from "react";
import { useParams } from "react-router-dom";
import { useProfile } from "../../context/ProfileContext";
import ThermalFormat from "./ThermalInvoiceDrawer";
import DotMatrixFormat from "./DotMatrixFormat";
import LaserFormat from "./LaserFormat";
import Letterhead from "./LetterheadFormat";

const FORMAT_COMPONENTS = {
  thermal: ThermalFormat,
  dotmatrix: DotMatrixFormat,
  laser: LaserFormat,
  inkjet: LaserFormat,
  letterhead: Letterhead,
};

export default function InvoicePreview({
  demoData = null,
  printerType: printerTypeProp = null,
  hideToolbar = false,
  isEditable = false, 
}) {
  const { formatType = "thermal" } = useParams();
  const { profileData } = useProfile();

  const targetType = printerTypeProp || formatType;
  const Format = FORMAT_COMPONENTS[targetType];

  if (!Format) return <div>Unknown format: {targetType}</div>;

  const rawProfile =
    profileData?.vendor || profileData?.data?.vendor || profileData || {};

  const finalDemoData = demoData
    ? {
        ...demoData,
        vendor: {
          name: rawProfile.name || rawProfile.brand_name || "",
          brand_name: rawProfile.brand_name || rawProfile.name || "",
          logo_url:
            rawProfile.logo_url ||
            rawProfile.logoDataUrl ||
            rawProfile.logo ||
            null,
          logoDataUrl:
            rawProfile.logoDataUrl ||
            rawProfile.logo_url ||
            rawProfile.logo ||
            null,
          address: rawProfile.address || "",
          phone: rawProfile.phone || "",
          email: rawProfile.email || "",
          gstin: rawProfile.gstin || "",
        },
      }
    : null;

  return (
    <Format
      demoData={finalDemoData}
      printerType={targetType}
      hideToolbar={hideToolbar}
      isEditable={isEditable} 
    />
  );
}
